"use client";

import NextImage, {
  ImageProps as NextImageProps,
  StaticImageData,
} from "next/image";
import { useEffect, useState } from "react";

export interface ImageProps extends NextImageProps {
  src: string | StaticImageData;
  alt: string;
}

const Image = ({
                 src,
                 alt,
                 priority,
                 objectFit,
                 objectPosition,
                 ...props
               }: ImageProps) => {
  const [showFallback, setShowFallback] = useState(false);
  const isExternalSrc = typeof src == "string";
  const [mounted, setMounted] = useState(false);
  let imgComponent = <></>;
  if (showFallback || !src) {
    imgComponent = (
      <NextImage
        src=""
        alt="Error"
        {...props}
      />
    );
  } else if (isExternalSrc) {
    imgComponent = (
      <img
        src={src}
        alt={alt}
        {...props}
        onError={() => setShowFallback(true)}
      />
    );
  } else {
    imgComponent = (
      <NextImage
        src={src}
        alt={alt}
        priority={priority}
        objectFit={objectFit}
        objectPosition={objectPosition}
        {...props}
      />
    );
  }

  useEffect(() => {
    if (mounted && !src) {
      setShowFallback(false);
    }
  }, [src]);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, [mounted]);

  if (!src) return;

  return imgComponent;
};

export default Image;
